import type { enStokWaste } from '../en/stok-waste';

export const idStokWaste: Record<keyof typeof enStokWaste, string> = {
  // ---- Reasons and statuses -------------------------------------------------------------
  'stok.wasteReason.spoilage': 'Busuk/rusak',
  'stok.wasteReason.expired': 'Kedaluwarsa',
  'stok.wasteReason.overproduction': 'Produksi berlebih',
  'stok.wasteReason.preparation_loss': 'Susut persiapan',
  'stok.wasteReason.contamination': 'Kontaminasi',
  'stok.wasteReason.breakage': 'Pecah/rusak',
  'stok.wasteReason.customer_return': 'Retur pelanggan',
  'stok.wasteReason.other': 'Lainnya',
  'stok.wasteStatus.draft': 'Draf',
  'stok.wasteStatus.submitted': 'Menunggu persetujuan',
  'stok.wasteStatus.approved': 'Disetujui',
  'stok.wasteStatus.posted': 'Diposting',
  'stok.wasteStatus.rejected': 'Ditolak',
  'stok.wasteStatus.cancelled': 'Dibatalkan',
  'stok.wasteStatus.reversed': 'Dibalik',

  // ---- List -----------------------------------------------------------------------------
  'stok.waste.title': 'Waste',
  'stok.waste.subtitle':
    'Stok yang dibuang di {branch}: dicatat, disetujui orang lain, lalu diposting ke buku stok.',
  'stok.waste.new': 'Catat waste',
  'stok.waste.reportLink': 'Laporan waste',
  'stok.waste.listReadOnly':
    'Peran Anda dapat melihat catatan waste, tetapi tidak dapat mencatatnya.',
  'stok.waste.tabsLabel': 'Catatan waste menurut status',
  'stok.waste.tab.mine': 'Menunggu persetujuan saya',
  'stok.waste.tab.all': 'Semua',
  'stok.waste.listDesc':
    'Terbaru dulu, maksimal 200 catatan. Nilai: nilai posting, atau estimasinya.',
  'stok.waste.searchPlaceholder': 'Nomor, item, SKU atau lot',
  'stok.waste.mineDesc': 'Diajukan orang lain dan menunggu keputusan Anda (pemisahan tugas).',
  'stok.waste.empty': 'Belum ada waste yang dicatat — pakai “Catat waste” saat stok dibuang.',
  'stok.waste.emptyReadOnly':
    'Belum ada waste yang dicatat — staf dapur dan gudang mencatatnya di sini.',
  'stok.waste.emptyMine': 'Tidak ada yang menunggu persetujuan Anda.',
  'stok.waste.emptyStatus': 'Tidak ada catatan waste dengan status ini.',
  'stok.waste.col.number': 'Nomor',
  'stok.waste.col.createdBy': 'Dicatat oleh',
  'stok.waste.postedOn': 'Tanggal usaha (diposting)',
  'stok.waste.estimated': 'Estimasi',
  'stok.waste.back': 'Semua waste',

  // ---- Form -----------------------------------------------------------------------------
  'stok.waste.newTitle': 'Catat waste',
  'stok.waste.newSubtitle':
    'Satu barang per catatan, di satu lokasi di {branch}. Stok baru berubah saat catatan diposting.',
  'stok.waste.readOnly': 'Peran Anda dapat melihat waste, tetapi tidak dapat mencatatnya.',
  'stok.waste.noPermission': 'Mencatat waste butuh izin waste. Minta bantuan manajer.',
  'stok.waste.noItems': 'Belum ada barang inventaris aktif — manajer perlu membuat barang dulu.',
  'stok.waste.noLocations': 'Tidak ada lokasi aktif',
  'stok.waste.formTitle': 'Apa yang dibuang',
  'stok.waste.editTitle': 'Ubah draf',
  'stok.waste.formDesc':
    'Jumlah boleh dalam satuan apa pun milik barang. Barang berlot wajib memilih lot yang dibuang.',
  'stok.waste.pickItem': 'Pilih barang…',
  'stok.waste.pickLot': 'Pilih lot…',
  'stok.waste.lotHint': 'Kedaluwarsa terdekat di atas. Pilih lot yang benar-benar dibuang.',
  'stok.waste.lotLoading': 'Memuat lot di lokasi ini…',
  'stok.waste.lotNone': 'Tidak ada lot barang ini yang bersisa stok di lokasi ini.',
  'stok.waste.lotAvailable': 'Stok lot ini di sini: {qty}.',
  'stok.waste.lotExpiry': 'kdl. {date} ({days})',
  'stok.waste.qty': 'Jumlah',
  'stok.waste.unit': 'Satuan',
  'stok.waste.inBase': 'Setara',
  'stok.waste.reason': 'Alasan',
  'stok.waste.pickReason': 'Pilih alasan…',
  'stok.waste.note': 'Catatan',
  'stok.waste.noteHint': 'Apa yang terjadi, contoh: “Kulkas 2 mati semalam”.',
  'stok.waste.draftNote': 'Disimpan sebagai draf. Tambahkan foto dan ajukan di layar berikutnya.',
  'stok.waste.saveDraft': 'Simpan draf',
  'stok.waste.saved': 'Waste {number} tersimpan.',
  'stok.waste.err.location': 'Pilih lokasi.',
  'stok.waste.err.item': 'Pilih barang.',
  'stok.waste.err.lot': 'Pilih lot yang dibuang.',
  'stok.waste.err.unit': 'Pilih satuan untuk barang ini.',
  'stok.waste.err.qty': 'Masukkan jumlah di atas 0 (maksimal 3 desimal).',
  'stok.waste.err.precision':
    'Jumlah ini tidak bisa dikonversi dengan tepat — pakai satuan yang lebih kecil.',
  'stok.waste.err.reason': 'Pilih alasan.',
  'stok.waste.err.note': 'Maksimal 500 karakter.',
  'stok.waste.err.noteRequired': 'Tulis catatan untuk keputusan ini.',
  'stok.waste.err.selfApproval':
    'Anda yang mencatat atau mengajukan waste ini, jadi Anda tidak bisa memutuskannya. Orang lain dengan izin persetujuan harus menyetujui atau menolaknya.',
  'stok.waste.err.insufficient': 'Stok di lokasi ini tidak cukup untuk waste ini.',
  'stok.waste.err.insufficientQty':
    'Stok di lokasi ini tidak cukup: tersedia {available}, diminta {requested}. Hitung ulang stok atau ubah jumlahnya.',
  'stok.waste.err.stateChanged':
    'Catatan ini sudah diubah orang lain. Kondisi terbarunya sudah dimuat.',

  // ---- Detail ---------------------------------------------------------------------------
  'stok.waste.detailLoading': 'Catatan waste',
  'stok.waste.detailTitle': 'Waste {number}',
  'stok.waste.detailSubtitle': '{item} · {location}',
  'stok.waste.factsTitle': 'Rincian',
  'stok.waste.factsDesc': 'Jumlah sesuai catatan, dan dalam satuan stok barang.',
  'stok.waste.liveEstimate': 'Estimasi nilai (terkini)',
  'stok.waste.liveEstimateHint':
    'Jumlah × biaya rata-rata saat ini. Dibekukan saat catatan diajukan.',
  'stok.waste.frozenEstimate': 'Estimasi nilai',
  'stok.waste.frozenEstimateHint':
    'Dibekukan saat diajukan; menentukan perlu tidaknya persetujuan.',
  'stok.waste.noEstimate': 'Tidak ada stok untuk dinilai',
  'stok.waste.approvalRequired': 'Perlu persetujuan',
  'stok.waste.approvalYes': 'Ya — sama dengan atau di atas batas cabang',
  'stok.waste.approvalNo': 'Tidak — di bawah batas cabang',
  'stok.waste.approvalUnknown': 'Ditentukan saat diajukan',
  'stok.waste.postedValue': 'Nilai posting',
  'stok.waste.postedValueHint': 'Dari buku stok dengan biaya rata-rata tertimbang.',
  'stok.waste.businessDate': 'Tanggal usaha',
  'stok.waste.movements': 'Mutasi buku stok',
  'stok.waste.reversalMovement': 'pembalikan {id}',
  'stok.waste.actionsTitle': 'Langkah berikutnya',
  'stok.waste.actionsReadOnly':
    'Peran Anda tidak dapat melakukan langkah berikutnya untuk catatan ini.',
  'stok.waste.info.draft':
    'Draf — stok belum berubah. Mengajukan akan membekukan estimasi nilai dan mengirimnya untuk disetujui bila perlu.',
  'stok.waste.info.awaiting': 'Menunggu persetujuan dari orang yang punya izin persetujuan.',
  'stok.waste.info.selfApproval':
    'Anda yang mencatat waste ini. Pemisahan tugas: orang lain dengan izin persetujuan harus menyetujui atau menolaknya.',
  'stok.waste.info.decide': 'Periksa jumlah, alasan, dan foto, lalu setujui atau tolak.',
  'stok.waste.info.decideOwn':
    'Anda yang mencatat waste ini. Pemisahan tugas nonaktif di cabang ini, jadi Anda boleh memutuskan — beri alasan; dicatat sebagai persetujuan sendiri.',
  'stok.waste.selfDecisionNote': 'Alasan (wajib saat menyetujui catatan sendiri)',
  'stok.waste.info.approved': 'Disetujui — posting untuk mengurangi stok di buku stok.',
  'stok.waste.info.posted':
    'Sudah diposting ke buku stok. Kesalahan dikoreksi dengan pembalikan, bukan dengan mengubah data.',
  'stok.waste.info.rejected': 'Ditolak — stok tidak berubah.',
  'stok.waste.info.reversed': 'Dibalik — stok dan nilainya sudah dikembalikan.',
  'stok.waste.info.cancelled': 'Dibatalkan — stok tidak berubah.',
  'stok.waste.submit': 'Ajukan',
  'stok.waste.submitting': 'Mengajukan…',
  'stok.waste.submitted': 'Diajukan untuk persetujuan.',
  'stok.waste.submittedAuto': 'Diajukan dan otomatis disetujui (di bawah batas).',
  'stok.waste.approve': 'Setujui',
  'stok.waste.approving': 'Menyetujui…',
  'stok.waste.approveTitle': 'Setujui waste {number}?',
  'stok.waste.approveBody': '{qty} {item}. Setelah disetujui, waste dapat diposting.',
  'stok.waste.decisionNote': 'Catatan',
  'stok.waste.approvedMsg': 'Waste disetujui.',
  'stok.waste.reject': 'Tolak',
  'stok.waste.rejecting': 'Menolak…',
  'stok.waste.rejectTitle': 'Tolak waste {number}?',
  'stok.waste.rejectBody': 'Stok tidak berubah. Pencatat akan melihat alasan Anda.',
  'stok.waste.rejectNote': 'Alasan penolakan',
  'stok.waste.rejectedMsg': 'Waste ditolak.',
  'stok.waste.post': 'Posting',
  'stok.waste.posting': 'Memposting…',
  'stok.waste.postTitle': 'Posting waste {number}?',
  'stok.waste.postBody':
    '{qty} {item} akan dikurangi dari {location} dengan biaya rata-rata saat ini.',
  'stok.waste.postWarning': 'Waste yang sudah diposting hanya bisa dikoreksi dengan pembalikan.',
  'stok.waste.postedMsg': 'Waste diposting ke buku stok.',
  'stok.waste.reverse': 'Balik',
  'stok.waste.reversing': 'Membalik…',
  'stok.waste.reverseTitle': 'Balik waste {number}?',
  'stok.waste.reverseBody':
    '{qty} dikembalikan ke {location} dengan nilai yang persis sama dengan yang keluar. Entri aslinya tetap ada di buku stok.',
  'stok.waste.reverseReason': 'Alasan pembalikan',
  'stok.waste.reversedMsg': 'Waste dibalik.',
  'stok.waste.cancel': 'Batalkan draf',
  'stok.waste.cancelling': 'Membatalkan…',
  'stok.waste.cancelTitle': 'Batalkan waste {number}?',
  'stok.waste.cancelBody': 'Draf ditutup dan tidak bisa diajukan lagi. Stok tidak berubah.',
  'stok.waste.cancelledMsg': 'Draf waste dibatalkan.',
  'stok.waste.timelineTitle': 'Riwayat',
  'stok.waste.timelineDesc': 'Waktu menurut zona waktu cabang ({timeZone}).',
  'stok.waste.tl.created': 'Dicatat',
  'stok.waste.tl.submitted': 'Diajukan',
  'stok.waste.tl.approved': 'Disetujui',
  'stok.waste.tl.autoApproved': 'Disetujui otomatis (di bawah batas persetujuan)',
  'stok.waste.tl.rejected': 'Ditolak',
  'stok.waste.tl.posted': 'Diposting',
  'stok.waste.tl.reversed': 'Dibalik',
  'stok.waste.tl.cancelled': 'Dibatalkan',

  // ---- Evidence -------------------------------------------------------------------------
  'stok.waste.evidence.title': 'Foto dan dokumen',
  'stok.waste.evidence.desc':
    'Bukti untuk pemberi persetujuan. Foto diperkecil ke 1600 px; PDF maksimal 5 MB.',
  'stok.waste.evidence.add': 'Tambah foto atau PDF',
  'stok.waste.evidence.preparing': 'Menyiapkan…',
  'stok.waste.evidence.uploading': 'Mengunggah…',
  'stok.waste.evidence.uploaded': 'Bukti ditambahkan.',
  'stok.waste.evidence.empty': 'Belum ada foto — tambahkan foto barang yang dibuang.',
  'stok.waste.evidence.emptyReadOnly': 'Tidak ada foto atau dokumen terlampir.',
  'stok.waste.evidence.errType': 'Pakai foto JPEG, PNG, atau WebP, atau file PDF.',
  'stok.waste.evidence.errSize': 'File terlalu besar — batasnya 5 MB.',
  'stok.waste.evidence.errDecode': 'Foto ini tidak bisa dibaca. Coba foto lain.',
  'stok.waste.evidence.open': 'Buka bukti {n} di tab baru',
  'stok.waste.evidence.photoAlt': 'Foto bukti {n} untuk waste {number}',
  'stok.waste.evidence.pdf': 'PDF {n}',
  'stok.waste.evidence.size': '{kb} KB',

  // ---- Report ---------------------------------------------------------------------------
  'stok.waste.report.title': 'Laporan waste',
  'stok.waste.report.subtitle': 'Biaya waste yang diposting di {branch}, dari buku stok.',
  'stok.waste.report.rangeTitle': 'Periode',
  'stok.waste.report.rangeDesc':
    'Tanggal usaha menurut zona waktu cabang ({timeZone}), maksimal {max} hari.',
  'stok.waste.report.rangeTooLong': 'Pilih periode maksimal 93 hari.',
  'stok.waste.report.period': '{from} – {to}',
  'stok.waste.report.total': 'Biaya waste',
  'stok.waste.report.totalDesc': 'Sudah dikurangi pembalikan, dalam {currency}.',
  'stok.waste.report.count': 'Catatan',
  'stok.waste.report.countDesc': 'Catatan waste yang diposting dalam periode ini.',
  'stok.waste.report.empty':
    'Tidak ada waste yang diposting pada periode ini — angka muncul setelah catatan waste diposting.',
  'stok.waste.report.byReason': 'Per alasan',
  'stok.waste.report.byItem': 'Per barang',
  'stok.waste.report.byCategory': 'Per kategori',
  'stok.waste.report.byLocation': 'Per lokasi',
  'stok.waste.report.byDay': 'Per hari',
  'stok.waste.report.bucketEmpty': 'Tidak ada data.',
  'stok.waste.report.records': 'Catatan',
  'stok.waste.report.recordsDesc':
    'Setiap catatan beserta mutasi buku stok asal nilainya. Buka catatan untuk rinciannya.',
  'stok.waste.report.def.scope': 'Cakupan',
  'stok.waste.report.def.value': 'Nilai',
  'stok.waste.report.def.drilldown': 'Rincian',
};
